import { TeContainer, TeText } from '@topcon/tuicl-react';
import styled from 'styled-components';

import { Section } from '../utils/styling';
import { BREAKPOINTS } from '../utils/breakpoints';

interface Props {
  text: string;
  children?: React.ReactNode;
}

const Header = ({ text, children }: Props) => {
  return (
    <Section>
      <HeaderContainer fill justifyContent="space-between" alignItems="center">
        <TeText size={20} weight={700}>
          {text}
        </TeText>
        {children}
      </HeaderContainer>
    </Section>
  );
};

export default Header;

const HeaderContainer = styled(TeContainer)`
  @media (max-width: ${BREAKPOINTS.mobile}) {
    flex-direction: column;
    align-items: flex-start !important;
    justify-content: flex-start !important;
    font-size: 14px !important;
    gap: 4px !important;
  }
`;
